var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("router-view"),
      _c(
        "SkinChange",
        [
          _vm.hasMain
            ? _c("TabBar", {
                attrs: {
                  data: _vm.tabBars,
                  "default-active": _vm.active,
                  "is-origin-from-brand": _vm.isOriginFromBrand,
                  "skin-change": _vm.newYearSkin,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      ["test", "development"].includes(_vm.vueAppEnv)
        ? _c(
            "div",
            {
              staticClass: "change-theme",
              on: { click: _vm.handleChangeTheme },
            },
            [_vm._v(" 切换主题 ")]
          )
        : _vm._e(),
      _vm.$route.path.includes("brand/details") ? _c("NoticeBar") : _vm._e(),
      _c("MandateAccount", {
        attrs: {
          "app-key": _vm.$route.query.appKey,
          phone: _vm.$route.query.phone,
          redirect: _vm.$route.query.redirect,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }